import * as featuresConfig from 'OK/pms!featuresConfiguration';
import { IFeaturesConfiguration } from '@ok/interfaces/features/IFeaturesConfiguration';
import { getSearchParamsFromUrl } from 'OK/URLUtils';

const { ignoredLayersForLoader } = featuresConfig as IFeaturesConfiguration;

const EVENT_START = 'navigationStart';
const EVENT_SUCCESS = 'navigationProcessed';
const EVENT_ERROR = 'navigationError';
const EVENT_ABORT = 'navigationAborted';

const STANDARD_LAYER_KEY = 'PopLayer';
const CMD_KEY = 'cmd';
const ST_LAYER_CMD_KEY = 'st.layer.cmd';
const LAYER_KEY = 'Layer';

type TNavigationEvent = CustomEvent<{
    url: string;
}>;

/**
 * Модуль обработки "нормальной" навигации (та, которая идёт через ICtrlRequestProcessHandler)
 */
export class NavigationHandler {
    endLoadLayer = (url: string) => {
        if (this.isLayerUrl(url)) {
            OK.Layers.endLoad();
        }
    }

    startHandler = (event: Event) => {
        const e = event as TNavigationEvent;
        const { url } = e.detail;

        if (this.isLayerUrl(url)) {
            OK.Layers.startLoad();
        }
    }

    successHandler = (event: Event) => {
        const e = event as TNavigationEvent;
        const { url } = e.detail;

        this.endLoadLayer(url);
    }

    errorHandler = (event: Event) => {
        const e = event as TNavigationEvent;
        const { url } = e.detail;

        this.endLoadLayer(url);
    }

    abortHandler = (event: Event) => {
        const e = event as TNavigationEvent;
        const { url } = e.detail;

        this.endLoadLayer(url);
    }

    isLayerUrl = (historyToken: string): boolean => {
        const params = getSearchParamsFromUrl(historyToken);

        let layerCmd = params.get(CMD_KEY);
        if (layerCmd === STANDARD_LAYER_KEY) {
            layerCmd = params.get(ST_LAYER_CMD_KEY);
        }

        // Считаем, что если ссылка содержит cmd=*Layer*, то это леер
        const isLayer = layerCmd?.includes(LAYER_KEY);

        if (!isLayer) {
            return false;
        }

        if (
          ignoredLayersForLoader.includes(layerCmd!)
          // Если открывается видео-плеер, то это не леер
          || (historyToken.includes('PopLayerVideo') && historyToken.includes('st.vpl.mini=true'))
        ) {
            OK.Layers.endLoad();
            return false;
        }
        return true;
    }

    activate(el: HTMLElement) {
        window.addEventListener(EVENT_START, this.startHandler);
        window.addEventListener(EVENT_SUCCESS, this.successHandler);
        window.addEventListener(EVENT_ERROR, this.errorHandler);
        window.addEventListener(EVENT_ABORT, this.abortHandler);
    }

    deactivate() {
        window.removeEventListener(EVENT_START, this.startHandler);
        window.removeEventListener(EVENT_SUCCESS, this.successHandler);
        window.removeEventListener(EVENT_ERROR, this.errorHandler);
        window.removeEventListener(EVENT_ABORT, this.abortHandler);
    }
}
